var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, Suspense } from 'react';
import MainLayout from '../../layouts/MainLayout';
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import InfiniteScroll from 'react-infinite-scroll-component';
import CircularProgress from '@material-ui/core/CircularProgress';
import './index.scss';
import { VIEW_RENDER_LIST } from '../../utils/Constant';
import { notificationSimple } from '../../utils/CommonUtil';
import * as LocalStorageUtil from '../../utils/LocalStorageUtil';
import * as Constant from "../../utils/Constant";
import { getNotificationData, markAsReadAllNotification, markAsReadNotification, deleteNotification } from '../../services/notification-service';
import { notificationGlobalData } from '../../store/notification/reducer';
import { notificationGlobalSuccess } from '../../store/notification/actions';
var Loading = function () { return React.createElement("div", null, "Loading..."); };
var LazyNotificationListWrapper = React.lazy(function () { return import('./components/notificationListWrapper'); });
var NotificationListWrapper = function (props) {
    return React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
        React.createElement(LazyNotificationListWrapper, __assign({}, props)));
};
var NotificationsPage = function (props) {
    var t = useTranslation().t;
    var history = useHistory();
    var match = props.match, notificationGlobalCountData = props.notificationGlobalCountData;
    var _a = useState(VIEW_RENDER_LIST), viewRender = _a[0], setViewRender = _a[1];
    var _b = useState(true), hasMore = _b[0], setMore = _b[1];
    var _c = useState([]), notificationData = _c[0], setNotificationData = _c[1];
    var _d = useState({
        size: 10
    }), notificationOption = _d[0], setOption = _d[1];
    var _e = useState(0), numberNotRead = _e[0], setNumberNotRead = _e[1];
    var _f = useState({
        minId: null,
        status: "ALL",
        keyword: ""
    }), paramInfinite = _f[0], setParamInfinite = _f[1];
    var _g = useState(false), isLoadingMarkAsReadAll = _g[0], setLoadingMarkAsReadAll = _g[1];
    var _h = useState(false), isLoading = _h[0], setLoading = _h[1];
    useEffect(function () {
        getNotification("DEFAULT", paramInfinite.status, paramInfinite.keyword);
        document.title = t("page.notifications") + Constant.APP_NAME;
    }, []);
    useEffect(function () {
        var view = VIEW_RENDER_LIST;
        setViewRender(view);
    }, [match]);
    useEffect(function () {
        setNumberNotRead(notificationGlobalCountData);
    }, notificationGlobalCountData);
    var getNotification = function (type, status, keyword) { return __awaiter(void 0, void 0, void 0, function () {
        var paramData, params, data, notificationPush, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    paramData = __assign(__assign({}, paramInfinite), { status: status, keyword: keyword });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setLoading(true);
                    params = {
                        size: notificationOption.size,
                        statuses: status == "ALL" ? "" : "NEW,SENT"
                    };
                    if (paramData.minId && type != "DEFAULT") {
                        params.minId = paramData.minId;
                    }
                    return [4 /*yield*/, getNotificationData(params)];
                case 2:
                    data = _a.sent();
                    notificationPush = type == "DEFAULT" ? data : notificationData.concat(data);
                    if (keyword) {
                        notificationPush = notificationPush.map(function (notification) {
                            var messageLower = notification.message.toLowerCase();
                            if (messageLower.indexOf(keyword.toLowerCase()) > -1) {
                                notification.isDisplay = true;
                            }
                            else {
                                notification.isDisplay = false;
                            }
                            return notification;
                        });
                    }
                    else {
                        notificationPush = notificationPush.map(function (notification) {
                            notification.isDisplay = true;
                            return notification;
                        });
                    }
                    if (data && data.length == 10) {
                        paramData.minId = data[data.length - 1].id;
                        setParamInfinite(paramData);
                    }
                    setMore(data.length == 10);
                    setNotificationData(notificationPush);
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setMore(true);
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var redirectToAction = function (url) {
        var location = {
            pathname: url,
        };
        history.push(location);
    };
    var onClickDeleteNotification = function (notification) { return __awaiter(void 0, void 0, void 0, function () {
        var notificationsClearData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm("Are you sure that you want to delete this notification?")) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteNotification(notification.id)];
                case 2:
                    _a.sent();
                    if ((!notification.toUsers || !notification.toUsers.length || 'SEEN' != notification.toUsers[0].status) && numberNotRead) {
                        props.dispatch(notificationGlobalSuccess(numberNotRead - 1));
                    }
                    notificationsClearData = notificationData.filter(function (notify) {
                        if (notify.id == notification.id) {
                            return false;
                        }
                        return true;
                    });
                    setNotificationData(notificationsClearData);
                    notificationSimple("Delete Notification Success!", Constant.NOTIFICATION_SUCCESS);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.log("Error delete Notification");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onClickNotification = function (notification) {
        if (!notification.toUsers || !notification.toUsers.length || 'SEEN' != notification.toUsers[0].status) {
            onClickMarkAsRead(notification);
        }
        else {
            if (notification.link) {
                if (notification.link.indexOf("/report-queue") > -1) {
                    redirectToAction("/report-queue");
                }
                else if (notification.link.indexOf("/alert") > -1 && notification.link.indexOf("/detail") > -1) {
                    var alertUrl = "/alert/" + notification.id + "/detail";
                    var paramAlertDetail = {
                        index: 0,
                        data: notification
                    };
                    LocalStorageUtil.storeItem(LocalStorageUtil.ALERT_KEY, JSON.stringify(paramAlertDetail));
                    redirectToAction(alertUrl);
                }
            }
        }
    };
    var onClickMarkAsRead = function (notification) { return __awaiter(void 0, void 0, void 0, function () {
        var notificationClearData, foundNotificationIndex, alertUrl, paramAlertDetail, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, markAsReadNotification(notification.id)];
                case 1:
                    _a.sent();
                    if (numberNotRead) {
                        props.dispatch(notificationGlobalSuccess(numberNotRead - 1));
                    }
                    notificationClearData = notificationData.map(function (notify) {
                        if (notify && notify.id == notification.id && notify.toUsers && notify.toUsers.length) {
                            notify.toUsers[0].status = 'SEEN';
                        }
                        return notify;
                    });
                    if (paramInfinite.status != "ALL") {
                        foundNotificationIndex = notificationClearData.findIndex(function (item) { return item.id == notification.id; });
                        if (foundNotificationIndex > -1) {
                            notificationClearData.splice(foundNotificationIndex, 1);
                        }
                    }
                    setNotificationData(notificationClearData);
                    if (notification.link) {
                        if (notification.link.indexOf("/report-queue") > -1) {
                            redirectToAction("/report-queue");
                        }
                        else if (notification.link.indexOf("/alert") > -1 && notification.link.indexOf("/detail") > -1) {
                            alertUrl = "/alert/" + notification.id + "/detail";
                            paramAlertDetail = {
                                index: 0,
                                data: notification
                            };
                            LocalStorageUtil.storeItem(LocalStorageUtil.ALERT_KEY, JSON.stringify(paramAlertDetail));
                            redirectToAction(alertUrl);
                        }
                    }
                    notificationSimple("Mark as Read Success!", Constant.NOTIFICATION_SUCCESS);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.log("Mark All Notification Error");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onClickMarkAllAsRead = function () { return __awaiter(void 0, void 0, void 0, function () {
        var notificationClearData, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoadingMarkAsReadAll)
                        return [2 /*return*/];
                    setLoadingMarkAsReadAll(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, markAsReadAllNotification()];
                case 2:
                    _a.sent();
                    if (numberNotRead) {
                        props.dispatch(notificationGlobalSuccess(null));
                    }
                    notificationClearData = notificationData.map(function (notify) {
                        if (notify && notify.toUsers && notify.toUsers.length) {
                            notify.toUsers[0].status = 'SEEN';
                        }
                        return notify;
                    });
                    if (paramInfinite.status != "ALL") {
                        notificationClearData = [];
                    }
                    setNotificationData(notificationClearData);
                    notificationSimple("Mark All as Read Success!", Constant.NOTIFICATION_SUCCESS);
                    setLoadingMarkAsReadAll(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    console.log("Mark All Notification Error");
                    setLoadingMarkAsReadAll(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onChangeSearch = function (keyword) {
        setParamInfinite(function (prevState) { return (__assign(__assign({}, prevState), { keyword: keyword })); });
        var notifications = notificationData.map(function (notification) {
            if (keyword) {
                var messageLower = notification.message.toLowerCase();
                if (messageLower.indexOf(keyword.toLowerCase()) > -1) {
                    notification.isDisplay = true;
                }
                else {
                    notification.isDisplay = false;
                }
            }
            else {
                notification.isDisplay = true;
            }
            return notification;
        });
        setNotificationData(notifications);
    };
    var onChangeStatus = function (status) {
        setParamInfinite(function (prevState) { return (__assign(__assign({}, prevState), { minId: null, keyword: "", status: status })); });
        getNotification("DEFAULT", status, paramInfinite.keyword);
    };
    return (React.createElement(MainLayout, null,
        React.createElement("div", { className: "notifications-container", id: "scrollableNotifications" },
            React.createElement(InfiniteScroll, { dataLength: notificationData.length, next: function () { return getNotification("NEXT", paramInfinite.status, paramInfinite.keyword); }, hasMore: hasMore, loader: React.createElement(Grid, { container: true, direction: "row", justify: "center" },
                    React.createElement(Grid, { lg: 4, md: 6, item: true },
                        React.createElement("div", { className: 'notification-page p0' },
                            React.createElement("div", { className: "notification-items m0" },
                                React.createElement("div", { className: "notification-item text-center" },
                                    React.createElement(CircularProgress, { size: 20 })))))), scrollableTarget: "scrollableNotifications", endMessage: React.createElement(Grid, { container: true, direction: "row", justify: "center" },
                    React.createElement(Grid, { lg: 4, md: 6, item: true },
                        React.createElement("div", { className: 'notification-page p0' },
                            React.createElement("div", { className: "notification-items m0" },
                                React.createElement("div", { className: "notification-item" },
                                    React.createElement("p", { className: 'text-center' },
                                        React.createElement("b", null, "Yay! You have seen it all"))))))) }, viewRender == VIEW_RENDER_LIST ?
                React.createElement(Grid, { container: true, direction: "row", justify: "center" },
                    React.createElement(Grid, { lg: 4, md: 6, item: true },
                        React.createElement(NotificationListWrapper, { notifications: notificationData, dispatch: props.dispatch, hasMore: hasMore, status: paramInfinite.status, keyword: paramInfinite.keyword, onChangeStatus: onChangeStatus, onClickDeleteNotification: onClickDeleteNotification, onClickNotification: onClickNotification, onClickMarkAllAsRead: onClickMarkAllAsRead, onChangeSearch: onChangeSearch, isLoading: isLoading }))) : null))));
};
function mapStateToProps(state) {
    return {
        notificationGlobalCountData: notificationGlobalData(state)
    };
}
export default connect(mapStateToProps)(NotificationsPage);
